if (!window.Eurus.loadedScript.includes('collar-atc-button-state.js')) {
  window.Eurus.loadedScript.push('collar-atc-button-state.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      /**
       * 通用的加购按钮状态管理 Alpine 组件，供购买区 Inline Add to Cart 按钮使用。
       * 根据当前选中变体的库存状态 + Coming Soon 配置，更新按钮文案 / 禁用状态 / data 属性。
       * 逻辑对齐 collar-cart-footer-compact.liquid 内联的 buttonStateManager，
       * 但抽成一份共享工厂（配置通过参数传入），避免每处渲染各自内联一份几乎相同的组件。
       */
      Alpine.data('xAtcButtonState', (config) => ({
        comingSoonInterval: null,

        // 判断 Coming Soon 是否仍处于生效状态（未启用 -> false；启用但没有倒计时 -> 一直生效；
        // 启用了倒计时 -> 倒计时结束时间是否已过）
        isComingSoonActive() {
          const comingSoon = config.comingSoon;
          if (!comingSoon || !comingSoon.enabled) return false;
          if (!comingSoon.countdownEnabled || !comingSoon.countdownEndTime) return true;

          const normalized = String(comingSoon.countdownEndTime).trim().replace(' ', 'T');
          const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized);
          const parsed = new Date(hasTimezone ? normalized : `${normalized}Z`);
          const endTime = parsed.getTime();
          return Number.isNaN(endTime) || endTime > Date.now();
        },

        // 更新按钮状态（文案、样式、禁用状态、data 属性）
        updateButtonState(variant) {
          if (!variant) return;

          const isAvailable = variant.available ?? true;
          const inventoryPolicy = variant.inventory_policy;
          const inventoryQuantity = variant.inventory_quantity;
          const isComingSoon = this.isComingSoonActive();

          let isSoldOut = false;
          let isPreOrder = false;

          if (inventoryPolicy !== undefined && inventoryQuantity !== undefined) {
            const allowsBackorder = inventoryPolicy === 'continue';
            const hasInventory = inventoryQuantity > 0;

            isSoldOut = !hasInventory && !allowsBackorder;
            isPreOrder = !hasInventory && allowsBackorder;
          } else {
            // 缺少库存字段时用 available 兜底，无法区分 Pre-Order，统一按 Sold Out 处理
            isSoldOut = !isAvailable;
            isPreOrder = false;
          }

          const isDisabled = isSoldOut || isComingSoon;
          const button = this.$el;
          const i18n = config.i18n || {};

          if (this.$refs.buttonText) {
            const label = isComingSoon
              ? i18n.comingSoon
              : isSoldOut
                ? i18n.soldOut
                : isPreOrder
                  ? i18n.preOrder
                  : i18n.addToCart;
            this.$refs.buttonText.innerHTML = '<span>' + label + '</span>';
          }

          button.classList.toggle('pre-order', isPreOrder || isComingSoon);
          button.disabled = isDisabled;
          button.setAttribute('data-available', isAvailable);
          button.setAttribute('data-inventory-policy', inventoryPolicy);
          button.setAttribute('data-inventory-quantity', inventoryQuantity);
          button.setAttribute('data-is-pre-order', isPreOrder);
          button.setAttribute('data-is-coming-soon', isComingSoon);
          button.setAttribute('data-is-sold-out', isSoldOut);
          button.setAttribute(
            'aria-label',
            isComingSoon ? i18n.comingSoon
              : isSoldOut ? i18n.soldOut
                : isPreOrder ? i18n.preOrder
                  : i18n.addToCart
          );
        },

        init() {
          const getCurrentVariant = () => Alpine.store(config.variantStoreName)?.currentVariant;

          this.updateButtonState(getCurrentVariant() || config.fallbackVariant);

          this.$watch(() => getCurrentVariant(), (newVariant) => {
            if (newVariant) this.updateButtonState(newVariant);
          });

          const comingSoon = config.comingSoon;
          if (comingSoon && comingSoon.countdownEnabled && comingSoon.countdownEndTime) {
            this.comingSoonInterval = setInterval(() => {
              this.updateButtonState(getCurrentVariant() || config.fallbackVariant);
            }, 1000);
          }
        },

        destroy() {
          if (this.comingSoonInterval) clearInterval(this.comingSoonInterval);
        }
      }));
    });
  });
}
